import { render, staticRenderFns } from "./CellarWineDetails.vue?vue&type=template&id=105a4b1c"
import script from "./CellarWineDetails.vue?vue&type=script&lang=js"
export * from "./CellarWineDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('105a4b1c')) {
      api.createRecord('105a4b1c', component.options)
    } else {
      api.reload('105a4b1c', component.options)
    }
    module.hot.accept("./CellarWineDetails.vue?vue&type=template&id=105a4b1c", function () {
      api.rerender('105a4b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/CellarWineDetails.vue"
export default component.exports